/* eslint-disable jsx-a11y/label-has-associated-control */

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import {
    Box,
    Card,
    Grid,
    Container,
    CardContent,
    CardActions,
    Typography,
} from "@mui/material";

import useForm from "../../hooks/validation";
import { styles } from "./style";
import Iconify from "../../components/iconify/iconify";
import LoadingButton from "../../shared/loadingButton/LoadingButton";
import {
    clientGrey,
    dateSlotStyle,
    dateStyle,
    placeholderStye,
} from "../../theme/style";
import MuiTextField from "../../theme/TextField";
import { getErrorMessage } from "../../utils";
import announcementServices from "../../services/announcementServices";
import {
    DatePicker,
    LocalizationProvider,
    TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import RichTextEditor from "../../components/RichTextEditor";

const initialValues = {
    description: "",
    title: "",
    date: "",
    time: "",
    location: "",
};

const validationRules = {
    description: (value) => (value ? "" : "This Field is required"),
    title: (value) => (value ? "" : "This Field is required"),
    date: (value) => (value ? "" : "This Field is required"),
    time: (value) => (value ? "" : "This Field is required"),
    location: (value) => (value ? "" : "This Field is required"),
};
const CreateAnnouncement = () => {
    const navigate = useNavigate();

    const { values, errors, handleOnChange, validateAllFields } = useForm(
        initialValues,
        validationRules
    );

    const [memberImage, setMemberImage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const fileSize = file.size / (1024 * 1024);
        if (fileSize > 3) {
            toast.error("File size exceeds the maximum limit of 3 MB.");
            return;
        }
        setMemberImage(file);
    };

    const handleRichTextChange = (content, fieldName) => {
        handleOnChange({ target: { name: fieldName, value: content } });
    };

    const handleSubmit = async () => {
        if (!memberImage || !(memberImage instanceof File)) {
            toast.error("Image is required");
            return;
        }
        const dateVal = values.date != null ? (dayjs.isDayjs(values.date) ? values.date : dayjs(values.date)) : null;
        const timeVal = values.time != null ? (dayjs.isDayjs(values.time) ? values.time : dayjs(values.time)) : null;
        const dateStr = dateVal && dateVal.isValid() ? dateVal.format("YYYY-MM-DD") : "";
        const timeStr = timeVal && timeVal.isValid() ? timeVal.format("HH:mm") : "";

        const formData = new FormData();
        formData.append("title", values.title ?? "");
        formData.append("description", values.description ?? "");
        formData.append("date", dateStr);
        formData.append("time", timeStr);
        formData.append("location", values.location ?? "");
        formData.append("file", memberImage);

        if (validateAllFields()) {
            setIsLoading(true);
            announcementServices
                .create(formData)
                .then(() => {
                    toast.success("Announcement created successfully");
                    navigate(-1);
                    setIsLoading(false);
                })
                .catch((err) => {
                    toast.error(getErrorMessage(err));
                    setIsLoading(false);
                });
        }
    };

    return (
        <Container>
            <Card sx={{ padding: "1rem" }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Box sx={styles.mainWrapper}>
                                <input
                                    type="file"
                                    name="staffProfileImage"
                                    id="staff_profile_img"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />
                                {memberImage ? (
                                    <Box sx={styles.imagePreviewBlock}>
                                        <Box sx={styles.imageWrapper}>
                                            <Box sx={{ width: "100%", height: "100%" }}>
                                                <img
                                                    height="100%"
                                                    src={URL.createObjectURL(memberImage)}
                                                    alt="Announcement"
                                                />
                                            </Box>
                                        </Box>
                                        <label htmlFor="staff_profile_img">
                                            <Typography
                                                component="span"
                                                variant="caption"
                                                sx={styles.changeImageLink}
                                            >
                                                <Iconify icon="eva:edit-2-outline" sx={{ width: 14, height: 14, mr: 0.5, verticalAlign: "middle" }} />
                                                Change image
                                            </Typography>
                                        </label>
                                    </Box>
                                ) : (
                                    <label
                                        htmlFor="staff_profile_img"
                                        style={{ cursor: "pointer", display: "block" }}
                                    >
                                        <Box sx={[styles.imageWrapper, styles.imageWrapperEmpty]}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: 700,
                                                    color: "#495057",
                                                    textAlign: "center",
                                                    lineHeight: 1.3,
                                                }}
                                            >
                                                Click here
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: "#495057",
                                                    textAlign: "center",
                                                    mt: 0.5,
                                                }}
                                            >
                                                to add image
                                            </Typography>
                                        </Box>
                                    </label>
                                )}
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <MuiTextField
                                label="title"
                                name="title"
                                value={values.title}
                                error={errors.title}
                                helperText={errors.title}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="title"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                pb="4px"
                                fontWeight={500}
                                fontSize={14}
                                color={clientGrey[500]}
                            >
                                Date
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker"]}>
                                    <DatePicker
                                        sx={dateStyle}
                                        slotProps={{
                                            ...dateSlotStyle,
                                            textField: {
                                                inputProps: {
                                                    placeholder: "DD/MM/YYYY",
                                                },
                                            },
                                        }}
                                        // value={dayjs(new Date(PersonalInfoFormValues.dob))}
                                        onChange={(value) => handleOnChange(value, "date")}
                                    // label=" Date"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            {errors?.date && (
                                <Typography pb="4px" fontWeight={500} fontSize={14} sx={{ color: "#fe7759 !important" }} color="#fe7759">
                                    {errors?.date}
                                </Typography>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                pb="4px"
                                fontWeight={500}
                                fontSize={14}
                                color={clientGrey[500]}
                            >
                                Time
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker"]}>
                                    <TimePicker
                                        sx={dateStyle}
                                        // value={dayjs(new Date(PersonalInfoFormValues.dob))}
                                        onChange={(value) => handleOnChange(value, "time")}
                                    // label=" Time"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            {errors?.time && (
                                <Typography pb="4px" fontWeight={500} sx={{ color: "#fe7759 !important" }} fontSize={14} color="#fe7759">
                                    {errors?.time}
                                </Typography>
                            )}
                            {/* <MuiTextField
                                label="Time"
                                name="time"
                                value={values.time}
                                error={errors.time}
                                helperText={errors.time}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="12:00 AM"
                            /> */}
                        </Grid>
                        <Grid item xs={12}>
                            <MuiTextField
                                label="location"
                                name="location"
                                value={values.location}
                                error={errors.location}
                                helperText={errors.location}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="location"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <RichTextEditor
                                label="Description"
                                value={values.description}
                                onChange={(content) => handleRichTextChange(content, "description")}
                                error={errors.description}
                                placeholder="Enter detailed description"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <LoadingButton
                        isLoading={isLoading}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Add Announcement
                    </LoadingButton>
                </CardActions>
            </Card>
        </Container>
    );
};

export default CreateAnnouncement;
